import { disablePageScroll, enablePageScroll } from 'scroll-lock';

const $ = jQuery.noConflict();

class MobileHeader {
    constructor(trigger = '.btn-hamburger', pbody = 'body', listParent = '.menu-item-has-children > a') {
        this.trigger = trigger;
        this.pbody = pbody;
        this.listParent = listParent;
    }

    init() {
        $(this.trigger).on('click', this.setNavState);
        $(this.listParent).on('click', this.setListState);
        this.resized();
        this.subMenu();
    }

    setNavState(e) {
        e.preventDefault();
        const body = $('body');

        if ($(this).hasClass('open')) {
            MobileHeader.hideWrapper(this, body);
        } else {
            MobileHeader.showWrapper(this, body);
        }
    }

    setListState(e) {
        e.preventDefault();
        if (!$(this).hasClass('open')) {
            $(this).addClass('open');
        } else {
            $(this).removeClass('open');
        }
    }

    static hideWrapper(el, body) {
        $(el).removeClass('open');
        $(el).next().removeClass('active');
        enablePageScroll();
    }

    static showWrapper(el, body) {
        $(el).addClass('open');
        $(el).next().addClass('active');
        disablePageScroll();
        $('.search-modal').slideUp(200);
    }

    resized() {
        if (!$(this.trigger).is(':visible') && $(this.trigger).hasClass('open')) {
            MobileHeader.hideWrapper(this.trigger, $(this.pbody));
        }

        $('.main-header__nav-mobile--wrapper').css({ 'height': `${window.innerHeight - $('.main-header').height()}px`, });

        const alertBar = $('.main-header__alert');
        $('.main-header__nav-mobile--wrapper .sub-menu').css(
            {
                'height': alertBar.is(':visible') ? `${window.innerHeight - alertBar.outerHeight()}px` : `${window.innerHeight}px`,
                'top': alertBar.is(':visible') ? `${alertBar.outerHeight()}px` : ''
            }
        );
    }

    hideOutsideClick(e) {
        if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
            const container = $('.main-header');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                MobileHeader.hideWrapper(this.trigger, $(this.pbody));
            }
        }
    }

    subMenu() {
        $('.main-header__nav-mobile .sub-menu').prepend('<li class="sub-menu__back">Back</li>');

        $('.main-header__nav-mobile').on(
            'click',
            '.sub-menu__back',
            event => {
                $(event.currentTarget).parent().prev().removeClass('open');
            }
        );
    }
}

export default new MobileHeader();
